import '../../App.css'
import { FaArrowRight } from "react-icons/fa";
import { FaGithubSquare } from "react-icons/fa";

function LastestProject() {
    return (
        <div className="lastest-project" id="project">
            <h2> Lastest Projects </h2>

            <div className='cards'>
                <div className='card project-animate'>
                    <div className='card-header'>
                        <h3 className='card-title'> myFinFriend </h3>
                        <img className="image-card" src="/pictures/myFinFriend.png" alt="myFinFriend"/>
                    </div>
                    <p> Allow the user to manage their finances efficiently. Giving them a AI friend that could read the pdf and calculate the frequency bill each months </p>
                    <div className='project-tech'>
                        <span> Python (flask) </span>
                        <span> ReactJS </span>
                        <span> GoogleGenai </span>
                        <span> Supabase </span>
                    </div>
                    <div className='end'>
                        <a href="https://github.com/huynhphihoang/myFinFriend/tree/main" className='card-button' target="_blank" rel="noopener noreferrer"> View </a>                    
                    </div>
                </div>
                <div className='card project-animate'>
                    <div className='card-header'>
                        <h3 className='card-title'> Pawpals </h3>
                        <img className="image-card" src="/pictures/pawpals-design.png" alt="pawpals"/>
                    </div>
                    <p> Giving the users a website that can help each other to find the lost pet. The website generates with AI to find the similarities of all images and announce the user if it is more than 80% similarities.</p>
                    <div className='project-tech'>
                        <span> Python (flask) </span>
                        <span> HTML/CSS </span>
                        <span> AWS S3 </span>
                        <span> Tensorflow </span>
                    </div>
                    <div className='end'>
                        <a href="https://github.com/Dang-Khoa-Nguyen/Pawpals" className='card-button' target="_blank" rel="noopener noreferrer"> View </a>
                    </div>
                </div>
            </div>

            {/*Button link to projects*/}
            <div  className='center'>
            <a href="https://github.com/Dang-Khoa-Nguyen" className='button-2'> 
                <FaGithubSquare/>
                Projects on Github
                <FaArrowRight/>
            </a>
            </div>
        </div>
    );
}

export default LastestProject;